export default __webpack_public_path__ + "static/media/post.82281641.svg";